<template lang="html">
  <LegalDocumentLayout
    :title="item?.title || fallbackTitle"
    :source-key="hasCmsContent ? undefined : 'privacy'"
  >
    <InfoCmsBody :item="item" :has-cms-content="hasCmsContent">
      <LegalDocumentBody :blocks="privacyPolicyBlocks" />
    </InfoCmsBody>
  </LegalDocumentLayout>
</template>

<script setup lang="ts">
import InfoCmsBody from '#Info/components/InfoCmsBody.vue'
import LegalDocumentBody from '#Info/components/LegalDocumentBody.vue'
import LegalDocumentLayout from '#Info/components/LegalDocumentLayout.vue'
import { useInfoCmsPage } from '#Info/composables/useInfoCmsPage'
import { infoCmsSlugs } from '#Info/constants/cmsPages'
import { privacyPolicyBlocks } from '#Info/content/privacyPolicy'

defineOptions({
  name: 'InfoPrivacyPage',
})

const fallbackTitle = 'Политика конфиденциальности'

const { item, hasCmsContent } = await useInfoCmsPage(infoCmsSlugs.privacyPolicy)

useContentSeo(item, { fallbackTitle })
</script>
